import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRightLong } from 'react-icons/fa6';
import { useSession } from '../../context/SessionContext';
import productServices from '../../services/ProductsServices';

function HomeCategories() {
    const { productTypes, hasProductTypes, setProductTypes } = useSession();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            setError(null);
            const res = await productServices.getProductTypes();
            setProductTypes(res.data);
        } catch (err) {
            console.error('Failed to fetch categories:', err);
            setError('Unable to load categories. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!hasProductTypes) {
            fetchCategories();
        } else {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasProductTypes]); // ✅ suppressed with comment — safe in your case (see reasoning below)

    const categories = hasProductTypes ? productTypes : [];

    if (loading) {
        return (
            <section className="py-10">
                <div className="container mx-auto px-4 text-center">
                    <p className="text-gray-500 dark:text-gray-400 font-bold">Loading categories...</p>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="py-10">
                <div className="container mx-auto px-4 text-center">
                    <p className="text-red-600">{error}</p>
                </div>
            </section>
        );
    }

    return (
        <section className="py-3">
            <div className="container mx-auto px-4">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
                        Shop By Category
                    </h2>
                    <div className="flex justify-center items-center">
                        <Link
                            to="/categories"
                            className="flex gap-3 mt-1.5 text-gray-600 hover:text-secondary transition-colors items-center"
                        >
                            View All Categories <FaArrowRightLong />
                        </Link>
                    </div>
                </div>

                {categories.length === 0 ? (
                    <div className="text-center text-gray-500 font-semibold">
                        No categories available.
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-8">
                        {categories.map((category) => (
                            <Link
                                key={category.id}
                                className="group relative block rounded-lg overflow-hidden shadow-lg"
                                to={`/products?product_type=${category.id}`}
                            >
                                <img
                                    alt={`${category.name} Category`}
                                    className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-300"
                                    src={category.image}
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                    <h3 className="text-white text-xl font-black uppercase tracking-wider">
                                        {category.name}
                                    </h3>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default HomeCategories;